import { SvgIcon } from '@material-ui/core';

export const IconExclamationCircle = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M11 18v-2h2v2h-2zm0-4V6h2v8h-2zM12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
